import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "keys",
  initialState: {},
  reducers: {
    GET_KEYS_LIST: (data, action) => {
      return { ...data, data: action.payload };
    },
  },
});

export const { GET_KEYS_LIST } = slice.actions;

export default slice.reducer;
